export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    title: {
      type: Array,
      default: () => [$t("18f3nab", "当前身份已开启登录保护"), $t("53vmhgk", "请打开身份验证器APP，输入显示的安全码")]
    }
  },
  data() {
    return {
      verificationCodes: ["", "", "", "", "", ""]
    };
  },
  computed: {
    activeElement() {
      return document.activeElement;
    }
  },
  methods: {
    validate(callback) {
      // 判断是否输入完成
      if (this.verificationCodes.join("").length === 6) {
        callback({
          valid: true,
          code: this.verificationCodes.join("")
        });
      } else {
        this.$Message.error($t("zapn0u8", "请输入正确安全码"));
        callback({
          valid: false
        });
      }
    },
    handleFocus(index, event) {
      const value = event.target.value;
      this.$nextTick(() => {
        event.target.setSelectionRange(0, value.length);
      });
    },
    handleInput(index, event) {
      const value = event.target.value;
      if (!/^[0-9]+$/.test(value)) {
        this.$nextTick(() => {
          event.target.value = "";
          this.verificationCodes[index] = "";
        });
        return this.verificationCodes[index] = "";
      }
      this.verificationCodes[index] = value;
      // 判断是否输入完成
      if (this.verificationCodes.join("").length === 6) {
        this.$emit("validate", this.verificationCodes.join(""));
      }
      // 自动跳到下一个输入框
      if (value && index < this.verificationCodes.length - 1) {
        const nextInput = event.target.nextElementSibling;
        if (nextInput) {
          this.$nextTick(() => {
            nextInput.focus();
          });
        }
      }
    },
    handleKeyDown(index, event) {
      // 处理删除操作
      if (event.key === "Backspace" && !event.target.value && index > 0) {
        const prevInput = event.target.previousElementSibling;
        if (prevInput) {
          this.$nextTick(() => {
            prevInput.focus();
          });
        }
      }
    },
    resetData() {
      this.verificationCodes = ["", "", "", "", "", ""];
      this.$nextTick(() => {
        this.$refs.inputList.firstElementChild.focus();
      });
    }
  },
  mounted() {
    this.verificationCodes = ["", "", "", "", "", ""];
  }
};